import React from 'react';
import { Box, Icon, Typography } from '@material-ui/core';

import SectionCard from '../../../components/SectionCard';
import useStyles from './styles';

const Locked = props => {
  const classes = useStyles();
  const { certificate, daysToRelease } = props;

  return (
    <SectionCard className={classes.container}>
      <Box className="content">
        <Box className="locked-title">
          <Icon className="locked-title-icon">lock</Icon>
          <Typography className="locked-title-text" variant="subtitle1">
            {`${certificate ? 'Certificado' : 'Conteúdo'} bloqueado`}
          </Typography>
        </Box>
        <Typography className="locked-description" variant="body2">
          {certificate &&
            'O certificado de conclusão do curso ainda não está liberado.'}
          {daysToRelease &&
            `O conteúdo desta aula estará disponível para visualização em ${daysToRelease} dias.`}
          {!certificate &&
            !daysToRelease &&
            'O conteúdo desta aula ainda não está disponível para visualização.'}
        </Typography>
      </Box>
    </SectionCard>
  );
};

export default Locked;
